var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2537_380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95457 25.872V12.5474L3.76072 8.76686L0 6.66895V23.5206C0 24.8217 1.06982 25.872 2.38643 25.872H7.95457Z",
    fill: "#112F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0454 25.872H32.6136C33.9341 25.872 35 24.8177 35 23.5206V6.66907L30.7404 9.07198L27.0454 12.5474V25.872Z",
    fill: "#112F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95445 12.5473L7.38379 7.34101L7.95445 2.35803L17.4999 9.41225L27.0453 2.35803L27.6837 7.07198L27.0453 12.5473L17.4999 19.6016L7.95445 12.5473Z",
    fill: "#112F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0454 2.35801V12.5473L35 6.66889V3.53367C35 0.625845 31.6312 -1.03182 29.2728 0.712062L27.0454 2.35801Z",
    fill: "#112F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66883L3.65846 9.37256L7.95457 12.5473V2.35795L5.72715 0.712002C3.36465 -1.03202 0 0.625784 0 3.53347V6.6687V6.66883Z",
    fill: "#112F4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2537_380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.e64ef4bdc527c717557056accb58c1df.svg";
export { ForwardRef as ReactComponent };